import { render } from "./thanh-cong.vue?vue&type=template&id=bc9f13d6&scoped=true"
import script from "./thanh-cong.vue?vue&type=script&lang=js"
export * from "./thanh-cong.vue?vue&type=script&lang=js"

import "./thanh-cong.vue?vue&type=style&index=0&id=bc9f13d6&lang=scss&scoped=true"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc9f13d6"]])

export default __exports__